'use client';
import { useState, useEffect, useRef } from 'react';
import { AxiosInstance} from '../utils';
import {ScheduleTab} from './scheduletab';
function ScheduleSection({eventInfo, LocalData}:any) {
    const [loading, setLoading] = useState(true);
    const [scheduleResp, setScheduleResp] = useState([]);
    const [tracks, setTracks] = useState([] as any);
    const [days, setDays] = useState([] as any);
    const [tabses, setTabses] = useState([] as any);
    const [hasProcessed, setHasProcessed] = useState(false);
    
    useEffect(() => {
        const fetchData = async () => {
            // Prevent multiple API calls
            if (hasProcessed) {
                return;
            }
            
            setLoading(true);
            try {
                let response: any = {};
                
                if (LocalData) {
                    response = {
                        result: "Success",
                        data: LocalData
                    }
                } else {
                    let { data: tempresponse } = await AxiosInstance.get('/api/getschedule?eventcode=' + eventInfo.eventcode);
                    response = tempresponse;
                }

                
                if (response.result !== "Success" || !response.data || response.data.length === 0) {
                    setLoading(false);
                    return;
                }

                // Group tracks by day
                const tracksByDay: { [key: string]: any[] } = {};
                
                // Process the response data structure
                response.data.forEach((dayData: any, index: number) => {
                    if (dayData.tracks && dayData.tracksOrder) {
                        
                        // Iterate through tracks in order
                        dayData.tracksOrder.forEach((trackId: string, trackIndex: number) => {
                            const track = dayData.tracks[trackId];
                            if (track) {
                                // Default to day 1 if day is not available, null, or empty
                                const day = track.day && track.day.toString().trim() !== '' ? track.day.toString() : '1';
                                if (!tracksByDay[day]) {
                                    tracksByDay[day] = [];
                                }
                                tracksByDay[day].push(track);
                            }
                        });
                    }
                });

                // Create tabs for each day
                const tempDays: any[] = [];
                const temptabs: any[] = [];
                let dayCounter = 1;
                
                Object.keys(tracksByDay).sort((a, b) => parseInt(a) - parseInt(b)).forEach(day => {
                    const dayTracks = tracksByDay[day];
                    const dayName = eventInfo.eventcode && eventInfo.eventcode.startsWith("atp") ? "Trainings" : "Day " + day;
                    const tabcounterkey = day + "_day_" + dayCounter;
                    
                    tempDays.push(
                        <li className="nav-item">
                            <a className={"nav-link " + (dayCounter == 1 ? " active show" : "")} id={`confery-tab${tabcounterkey}`} data-toggle="tab" href={`#confery${tabcounterkey}`} role="tab" aria-controls={`confery${tabcounterkey}`} >
                                <strong>{dayName}</strong>
                            </a>
                        </li>
                    );
                    
                    temptabs.push(<ScheduleTab key={tabcounterkey} parentToChild={dayTracks} tabidcounter={tabcounterkey} generalcounter={dayCounter} />);
                    dayCounter++;
                });

                // Update state only once
                setDays(tempDays);
                setTabses(temptabs);
                setScheduleResp(response);
                setHasProcessed(true);
                
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        
        fetchData();

        return () => {
            // Cleanup function
        };
    }, [eventInfo.eventcode, LocalData]); // Add dependencies to prevent unnecessary re-runs
    return(
        <section className="conference-sec" id="schedule" data-scroll-index="2">
        <div className="container">
            <div className="sec-title">
                <span className="icon-inner wow flipInY" data-wow-duration="300ms">
                    <span className="fa-stack">
                        <i className="fa rhex fa-stack-2x"></i>
                        <i className="fa fa-calendar fa-stack-1x"></i>
                    </span>
                </span>

                {LocalData ? (
                    <h3 className="wow fadeInRight" data-wow-duration="500ms"> Agenda -PREVIEW </h3>
                ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", flexWrap: "wrap" }}>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms"> Agenda{" "} <small> / {eventInfo.eventcode == "atp2026" ? "Super Charged Sessions" : "Deep Learning Experience"} </small> </h3>
                        {(eventInfo.eventcode === "atp2026" || eventInfo.eventcode === "acsc2026") && (
                            <a href={`/event/${eventInfo.eventcode}/register`} className="btn-default register-schedule-btn">
                                {eventInfo.eventcode === "atp2026" ? "Register for Training" : "Register for Conference"}
                            </a>
                        )}
                    </div>
                )}
            </div>    

            {
               days.length == 0 && <h2>Loading .......</h2>
            }
            <div className="conference-tabs-sec wow fadeIn" data-wow-duration="200ms">
                <div className="conf-tab-list">
                    <ul className="nav nav-tabs wow fadeInUp" data-wow-delay=".2s" id="myTab" role="tablist">
                       {days}
                    </ul> {/* <!--tabs-list end--> */}
                </div>
                <div className="tab-content" id="myTabContent">
                {tabses}
                </div>
            </div> {/* <!--conference-tabs-sec end--> */}
        </div>
    </section> 
    )};
export {ScheduleSection};
